import Text from "@/components/base/text";
import { IconLink } from "@/components/base/iconlink/IconLink";
import Icon from "@/components/base/icon/Icon";
import styles from "./ChoosePeriodicaCopyRow.module.css";
import ChevronRight from "@/public/icons/chevron_right.svg";
import ExclamationmarkSvg from "@/public/icons/exclamationmark.svg";
import Translate from "@/components/base/translate";
import { usePeriodicaForm } from "@/components/hooks/order";

/**
 * Shows a button to open the periodica form modal
 * button text depends on if the user has already filled out the form or not
 * @param {Object} periodicaForm //provided when coming from single order
 * @param {Object} periodicaForms //provided when coming from mutliorder
 * @param {Object} modal
 * @param {String} articleTypeTranslation
 * @returns
 */
export default function ChoosePeriodicaCopyRow({
  modal,
  articleTypeTranslation,
  workId,
}) {
  const { periodicaForm } = usePeriodicaForm(workId);

  return (
    <>
      {articleTypeTranslation ? (
        <div className={styles.articletype}>
          <Text type="text4">{Translate(articleTypeTranslation)}</Text>
        </div>
      ) : null}
      {periodicaForm && (
        <div>
          {Object.entries(periodicaForm).map(([key, value]) => (
            <span key={key} className={styles.periodicaformfield}>
              <Text type="text3">
                {Translate({
                  context: "order-periodica",
                  label: `label-${key}`,
                })}
              </Text>
              <Text type="text4" key={key}>
                {": "}
                {value}
              </Text>
            </span>
          ))}
        </div>
      )}
      <div className={styles.choosePeriodicaCopyRow}>
        {!periodicaForm && (
          <Icon
            alt="info"
            data-cy="tooltip-icon"
            size="2_5"
            className={styles.exclamationmark}
          >
            <ExclamationmarkSvg />
          </Icon>
        )}
        <IconLink
          onClick={() => {
            modal.push("periodicaform", {
              workId: workId,
            });
          }}
          className={styles.periodicaformlink}
          border={{ bottom: { keepVisible: true }, top: false }}
          tag={"button"}
          iconSrc={ChevronRight}
          iconPlacement={"right"}
        >
          {Translate({
            context: "order-periodica",
            label: periodicaForm ? "correct" : "title",
          })}
        </IconLink>
      </div>
    </>
  );
}
